var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCertora = function SvgCertora(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.848 1v16.565L10.424 23 1 17.565V1h18.848Z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 0.81
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.424 1.259 9.424 5.435v10.87L10.424 23 1 17.565V6.695l9.424-5.436Z",
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 0.81
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.424 1.259 9.424 16.306L10.424 23 1 17.565l9.424-16.306Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1.229 6.8 18.467 10.72M19.712 6.8 1.229 17.52M10.47 1.502V22.71M10.424 1.365 1.197 17.473M10.395 1.259l9.317 16.214M10.424 1.259l9.424 5.435v10.87L10.424 23 1 17.565V6.695l9.424-5.436Z",
    stroke: "currentColor",
    strokeWidth: 0.81
  })));
};
export default SvgCertora;